import React from "react";

// A duller, more muted take on SearchResults.css's `.searchResult em`
// highlight color (--lw-gold) — same yellow family, minus both the
// italic/bold that carries along with that `<em>` tag and the brightness,
// which reads as too loud against Browse/Search's compact rows. Wraps every
// case-insensitive occurrence of `query` found in `text`. Used by both the
// Search and Browse tabs of AiAddContextModal, against whatever text the
// row is currently searched/filtered by.
const HIGHLIGHT_COLOR = "#e0d27a";

const HighlightedText = ({ text, query }) => {
	const str = text == null ? "" : String(text);
	const needle = (query || "").trim();
	if (!needle) return str;

	const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	const parts = str.split(new RegExp(`(${escaped})`, "gi"));
	if (parts.length < 2) return str;

	return parts.map((part, i) =>
		part.toLowerCase() === needle.toLowerCase() ? (
			<span key={i} style={{ backgroundColor: HIGHLIGHT_COLOR }}>
				{part}
			</span>
		) : (
			part
		)
	);
};

export default HighlightedText;
